<template>
  <div class="con">
    <div class="con_title">{{ title }}</div>
    <div class="con_c">
      <div class="con_c_title">
        <div class="t_left">{{ leftTitle }}</div>
        <div class="t_right">{{ rightTitle }}</div>
      </div>
      <div class="con_c_con">
        <div class="con_c_tabbox">
          <div
            :class="{ active_listbg: openSwitch === index, tab_list: true, 'height-120': index === 3 }"
            @click="openSwitch = index"
            v-for="(item, index) in leftList"
            :key="index"
          >
            <div class="list_t">{{ item.title }}</div>
            <div class="list_c">{{ item.desc }}</div>
          </div>
        </div>

        <div v-show="openSwitch === index" class="tab_con" v-for="(item, index) in rightList" :key="index">
          <div class="con_title">{{ item.title }}</div>
          <div class="con_subtitle">{{ item.subTitle }}</div>
          <img :src="item.img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    leftTitle: String,
    rightTitle: String,
    leftList: Array,
    rightList: Array,
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
}
</script>

<style lang="less" scoped>
.con {
  width: 100%;
  background: #f7f7f7;
  height: 710px;
  margin-top: -10px;
  padding-top: 70px;
  position: relative;
  z-index: 999;
}

.con_title {
  font-size: 36px;
  text-align: center;
  color: #333;
  display: flex;
  justify-content: center;
}

.con_c {
  width: 1200px;
  height: 520px;
  margin: 40px auto;
  border: 1px solid #ececec;

  .con_c_title {
    height: 40px;
    width: 100%;
    display: flex;
    font-size: 16px;

    .t_left {
      width: 459px;
      line-height: 40px;
      background: #494949;
      text-align: center;
      color: #fff;
    }

    .t_right {
      width: 742px;
      line-height: 40px;
      text-align: center;
      background: #e61717;
      color: #fff;
    }
  }

  .tab_list {
    width: 100%;
    height: 119px;
    padding-left: 70px;
    padding-top: 25px;
    padding-right: 55px;
    cursor: pointer;
    border-bottom: 1px solid #ececec;

    .list_t {
      color: #e61717;
      font-size: 16px;
      font-family: '黑体';
      font-weight: 700;
    }

    .list_c {
      color: #333;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      margin-top: 5px;
    }
  }

  .con_c_con {
    width: 100%;
    height: 479px;
    display: flex;
    background: #fff;
  }

  .con_c_tabbox {
    width: 459px;
    background: #f7f7f7;

    .border-bt-0 {
      border-bottom: 0 !important;
    }

    .height-120 {
      height: 120px;
    }

    .active_listbg {
      background: #fff;
      border-left: 5px solid #e61717;
    }

    .no_active_listbg {
      background: #f7f7f7;
      border-left: 0;
    }
  }

  .con_subtitle {
    font-size: 14px;
    text-align: center;
    line-height: 28px;
  }

  .tab_con {
    width: 741px;
    padding-top: 30px;
    color: #333;
    border-bottom: 1px solid #ececec;

    img {
      width: 584px;
      height: 355px;
      display: flex;
      margin: 33px auto 0;
    }
  }
}
</style>
